import React, { useEffect, useState } from "react";
import { ReactComponent as Timer } from "../../assets/images/timer.svg";
// import CampaignList from "../Agent/CampaignList";
import AgentChart from "../../components/Charts/AgentChart";
import RightBar from "../../components/Dashboard/CallSidebar/RightBar";
import LineCharts from "../../components/Charts/LineCharts";
import { CamptheadData } from "../../utils/Data";
// import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";
import CampaignList from "../Agent/CampaignList";
import useAuth from "../../hooks/useAuth";
import axios from "../../utils/axios";
import useSocket from "../../hooks/useWebsocket";
import Swal from "sweetalert2";

const Dashboard = () => {

  useEffect(() => {
      const blockBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, "", window.location.pathname);
      };
  
      // Add a dummy state so back button triggers popstate
      window.history.pushState(null, "", window.location.pathname);
      window.addEventListener("popstate", blockBack);
  
      return () => {
        window.removeEventListener("popstate", blockBack);
      };
    }, []);

  const axiosPrivate = UseAxiosPrivate("dashboard call");
  const [admindashdata, setadmindashdata] = useState({});
  const [isReady, val, send, disconnect] = useSocket();

  const navigate = useNavigate()


  const [dashdata, setdashdata] = useState({
    total_calls: 0,
    answerd_calls: 0,
    call_duration: 0,
    avarege_response: 0,
    label: [],
    called_data: [],
    tobe_called: [],
    answerd_percentage: [],
  });

  const [recentCalls, setRecentCalls] = useState({});
  const [agentstatus, setAgentStatus] = useState({});

  const BASE_URL = process.env.REACT_APP_API_URL;

  const [invalidData,setInvalidData] = useState({
    "invalidDataStatus":false,
    "failed_data_list":[],
    "camp_id":null,
    "mixed_data_file":[]
  })

  const { auth } = useAuth();
  
  const user_id = auth?.user_details?.user;

  const userid = auth?.user_details?.id;
  
  useEffect(() => {
    if(val && val?.action === "failed_data_list" && val?.sender === "failed_data_list"){
      setInvalidData({
        "invalidDataStatus":true,
        "failed_data_list":val?.data?.failed_data_list || [],
        "camp_id": val?.data?.camp_id ||null,
        "mixed_data_file":val?.data?.mixed_data_file || []
      })
    }
    else{
      setInvalidData({
        "invalidDataStatus":false,
        "failed_data_list":[],
        "camp_id":null,
        "mixed_data_file":[]
      })
    }
  }, [val]);
  
  
  useEffect(() => {
    if (!invalidData) return;  // ignore empty messages
    console.log("invalidData")    
    // Only fire Swal for campaign upload completion
    // alert(JSON.stringify(invalidData))
    if (invalidData?.invalidDataStatus === true) {
      console.log("invalidDataStatus is True")
      var count = invalidData?.failed_data_list?.length
      var text_here = ""
      if(count>0){
        if (count===1){
          text_here=`${count} record has invalid data`
        } else{
          text_here=`${count} records have invalid datas`
        }
      }
      
      Swal.fire({
        title: "Campaign data upload completed",
        html:`<i style="color:red">${text_here}<i/>`,
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "EDIT THE CAMPAIGN",
      }).then((result)=>{
        val.action = ""
        setInvalidData({
          "invalidDataStatus":false,
          "failed_data_list":[],
          "camp_id":null,
          "mixed_data_file":[]
        })
        if(result.isConfirmed){
          navigate(`/admin/campaign/create/${invalidData?.camp_id}`)
        }
      });
    }
  }, [invalidData]);
  
  
  
  // useEffect(() => {
    //   if (!val) return;  // ignore empty messages
    //   console.log("val?.action")    
    //   // Only fire Swal for campaign upload completion
    //   if (val?.action === "failed_data_list" && val?.sender === "failed_data_list") {
      //     console.log("failed")
      //     var count = val?.data?.failed_data_list?.length
      //     var text_here = ""
      //     if(count>0){
        //       if (count===1){
          //         text_here=`${count} record has invalid data`
          //       } else{
            //         text_here=`${count} records have invalid datas`
            //       }
            //     }
            
            //     Swal.fire({
              //       title: "Campaign data upload completed",
              //       html:`<i style="color:red">${text_here}<i/>`,
              //       showCancelButton: true,
              //       cancelButtonColor: "#d33",
              //       confirmButtonText: "EDIT THE CAMPAIGN",
              //     }).then((result)=>{
                //       val.action = ""
                //       if(result.isConfirmed){
                  //         navigate(`/admin/campaign/create/${val?.data?.camp_id}`)
                  //       }
                  //     });
                  //   }
                  // }, [val]);
                  
                  
                  
                  
                  // useEffect(() => {
                    //   const adminId = auth?.user_details?.user;
                    //   const ws = new WebSocket(`ws://server/ws/admin/${adminId}/`);
                    
                    //   ws.onmessage = (e) => {
                      //     const msg = JSON.parse(e.data);
                      //     alert(msg)
                      
                      //     if (msg.event === "excel_upload_completed") {
                        //       alert("Campaign Excel upload completed!");
                        //     }
                        //   };
                        
                        //   return () => ws.close();
                        // }, []);
                        
                        
                        
                        
                        
                        
                        
                        
                        
                        const fetchDashboardData = async () => {
                          let user_id = auth?.user_details?.user;
                          
                          let config = {
                            headers: { "Content-Type": "application/json" },
                          };
                          
                          await axios
                          .get(
                            process.env.REACT_APP_API_URL +
                            "/contactcentre/call_count/" +
                            user_id +
                            "/" +
                            "admin/",
                            config
                          )
                          .then((res) => {
                            setdashdata((prev) => {
                              return {
                                ...prev,
                                total_calls: res.data.total_calls,
                                answerd_calls: res.data.answerd_calls,
                                call_duration: res.data.call_duration,
                                avarege_response: res.data.avarege_response,
                                
                                label: res.data.label,
                                called_data: res.data.called_data,
                                tobe_called: res.data.tobe_called,
                                answerd_percentage: res.data.answerd_percentage,
                                months: res.data?.months || [],
                                answerd: res.data?.answed || [],
                                not_answerd: res.data?.not_answed || [],
                                months: res.data?.months || [],
                                answerd: res.data?.answed || [],
                                not_answerd: res.data?.not_answed || [],
                              };
                            });
                            fetchRecentCalls();
                          })
                          .then(console.log("=============data loaded========="))
                          .catch((err) => console.log(err));
                        };
                        
                        const fetchRecentCalls = async () => {
                          let config = {
                            headers: { "Content-Type": "application/json" },
    };
    
    await axios
    .get(
      BASE_URL + "/contactcentre/recent-calls/" + user_id + "/",
      {},
      config
    )
    .then((response) => {
      setRecentCalls((prev) => {
        return {
          ...prev,
          recent_calls: response?.data?.recent_calls || [],
          recent_calls_objs: response?.data?.recent_calls_objs || [],
        };
      });
      FetchAgentStatus();
    })
    .catch((err) => console.log(err));
  };
  
  
  
  const [creditData, setCreditData] = useState([]);
  
  const FetchCreditData = async () => {
    let config = {
      headers: { "Content-Type": "application/json" },
    };
    
    await axiosPrivate
    .get(
      process.env.REACT_APP_API_URL +
      "/contactcentre/credit/" +
      userid +
      "/",
      {},
      config
    )
    .then((response) => {
      setCreditData(response.data); // Assuming the response contains the data you need
    })
    .catch((error) => {
      console.error("Error fetching live call data:", error);
    });
  };
  
  
  const FetchAgentStatus = async () => {
    axios
    .get(BASE_URL + "/contactcentre/agent_status/" + user_id + "/")
    .then((response) => {
        setAgentStatus(response.data);
      });
    };

    useEffect(() => {
      fetchDashboardData();
      FetchCreditData();
    }, []);
    
    return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-auto mt-[0.9rem]">
      <div className="col-span-2">
        <div className="bg-white rounded-lg font-lato">
          {/* CAll details card */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  rounded-md">
            <div className="bg-back-white flex justify-between pl-6 py-3  mt-2 mb-2 rounded-md">
              <div className="flex justify-start">
                <div className="bg-green-100 p-2 h-11 w-11 mt-1 rounded-md flex justify-center items-center">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.9588 6.60958L8.9923 11.5866L7.0498 9.63358C6.85208 9.43586 6.58391 9.32478 6.3043 9.32478C6.02468 9.32478 5.75652 9.43586 5.5588 9.63358C5.36108 9.8313 5.25 10.0995 5.25 10.3791C5.25 10.5175 5.27727 10.6546 5.33025 10.7825C5.38324 10.9105 5.4609 11.0267 5.5588 11.1246L8.2468 13.8126C8.34441 13.911 8.46054 13.9891 8.58849 14.0424C8.71644 14.0957 8.85368 14.1232 8.9923 14.1232C9.13091 14.1232 9.26815 14.0957 9.3961 14.0424C9.52405 13.9891 9.64019 13.911 9.7378 13.8126L15.4498 8.10058C15.5477 8.00268 15.6254 7.88645 15.6783 7.75854C15.7313 7.63063 15.7586 7.49353 15.7586 7.35508C15.7586 7.21663 15.7313 7.07953 15.6783 6.95162C15.6254 6.8237 15.5477 6.70748 15.4498 6.60958C15.3519 6.51168 15.2357 6.43402 15.1078 6.38104C14.9798 6.32805 14.8427 6.30078 14.7043 6.30078C14.5658 6.30078 14.4287 6.32805 14.3008 6.38104C14.1729 6.43402 14.0567 6.51168 13.9588 6.60958Z"
                      fill="#01B375"
                    />
                    <path
                      d="M10.5 0C8.4233 0 6.39323 0.615814 4.66652 1.76957C2.9398 2.92332 1.59399 4.5632 0.79927 6.48182C0.00454948 8.40045 -0.203386 10.5116 0.201759 12.5484C0.606904 14.5852 1.60693 16.4562 3.07538 17.9246C4.54383 19.3931 6.41476 20.3931 8.45156 20.7982C10.4884 21.2034 12.5996 20.9955 14.5182 20.2007C16.4368 19.406 18.0767 18.0602 19.2304 16.3335C20.3842 14.6068 21 12.5767 21 10.5C21 9.12112 20.7284 7.75574 20.2007 6.48182C19.6731 5.2079 18.8996 4.05039 17.9246 3.07538C16.9496 2.10036 15.7921 1.32694 14.5182 0.799265C13.2443 0.271591 11.8789 0 10.5 0ZM10.5 18.9C8.83864 18.9 7.21459 18.4073 5.83321 17.4843C4.45184 16.5613 3.37519 15.2494 2.73942 13.7145C2.10364 12.1796 1.93729 10.4907 2.26141 8.86124C2.58552 7.2318 3.38555 5.73506 4.56031 4.5603C5.73507 3.38554 7.23181 2.58552 8.86125 2.2614C10.4907 1.93729 12.1796 2.10364 13.7145 2.73941C15.2494 3.37519 16.5613 4.45184 17.4843 5.83321C18.4074 7.21458 18.9 8.83864 18.9 10.5C18.9 12.7278 18.015 14.8644 16.4397 16.4397C14.8644 18.015 12.7278 18.9 10.5 18.9Z"
                      fill="#01B375"
                    />
                  </svg>
                </div>
                <div className="pl-2">
                  <div className=" text-black font-[700] text-[20px]">
                    {dashdata.total_calls}
                  </div>
                  <p className="text-slate-500 text-sm pr-12">
                    Completed Calls
                  </p>
                </div>
              </div>
              <div className="h-[60px] bg-[#BFC7CD] w-[1.5px]"></div>
            </div>

            <div className="bg-back-white flex justify-between pl-6 py-3 mt-2 mb-2 rounded-md">
              <div className="flex justify-start">
                <div className="bg-purple-100 p-2 h-11 w-11 mt-1 rounded-md flex justify-center items-center">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5 0C8.4233 0 6.39323 0.615814 4.66652 1.76957C2.9398 2.92332 1.59399 4.5632 0.799269 6.48182C0.00454948 8.40044 -0.203386 10.5116 0.201759 12.5484C0.606904 14.5852 1.60693 16.4562 3.07538 17.9246C4.54383 19.3931 6.41476 20.3931 8.45156 20.7982C10.4884 21.2034 12.5996 20.9955 14.5182 20.2007C16.4368 19.406 18.0767 18.0602 19.2304 16.3335C20.3842 14.6068 21 12.5767 21 10.5C21 9.12112 20.7284 7.75574 20.2007 6.48182C19.6731 5.2079 18.8996 4.05039 17.9246 3.07538C16.9496 2.10036 15.7921 1.32694 14.5182 0.799265C13.2443 0.271591 11.8789 0 10.5 0ZM10.5 18.9C8.83864 18.9 7.21459 18.4073 5.83321 17.4843C4.45184 16.5613 3.37519 15.2494 2.73942 13.7145C2.10364 12.1796 1.93729 10.4907 2.26141 8.86124C2.58552 7.2318 3.38555 5.73506 4.56031 4.5603C5.73507 3.38554 7.2318 2.58552 8.86125 2.2614C10.4907 1.93729 12.1796 2.10364 13.7145 2.73941C15.2494 3.37519 16.5613 4.45184 17.4843 5.83321C18.4073 7.21458 18.9 8.83863 18.9 10.5C18.9 12.7278 18.015 14.8644 16.4397 16.4397C14.8644 18.015 12.7278 18.9 10.5 18.9ZM13.755 11.1615L11.55 9.891V5.25C11.55 4.97152 11.4394 4.70445 11.2425 4.50754C11.0456 4.31062 10.7785 4.2 10.5 4.2C10.2215 4.2 9.95445 4.31062 9.75754 4.50754C9.56063 4.70445 9.45 4.97152 9.45 5.25V10.5C9.45 10.5 9.45 10.584 9.45 10.626C9.45622 10.6983 9.47394 10.7692 9.5025 10.836C9.52413 10.8983 9.55228 10.9581 9.5865 11.0145C9.61524 11.0742 9.65045 11.1305 9.6915 11.1825L9.8595 11.319L9.954 11.4135L12.684 12.9885C12.844 13.0792 13.0251 13.1263 13.209 13.125C13.4415 13.1266 13.6679 13.051 13.8528 12.9101C14.0378 12.7692 14.1707 12.5708 14.2307 12.3462C14.2908 12.1216 14.2746 11.8835 14.1847 11.669C14.0948 11.4546 13.9363 11.2761 13.734 11.1615H13.755Z"
                      fill="#8661D4"
                    />
                  </svg>
                </div>
                <div className="pl-2">
                  <div className=" text-black font-[700] text-[20px]">
                    {dashdata.call_duration}
                  </div>
                  <p className="text-slate-500 text-sm pr-12">
                    Total Calls in Hour
                  </p>
                </div>
              </div>
              {/* <div className="h-[60px] bg-[#BFC7CD] w-[1.5px]"></div> */}
            </div>

            {/* <div className="bg-back-white flex justify-between pl-6 py-3  mt-2 mb-2 rounded-md">
              <div className="flex justify-start">
                <div className="bg-orange-100 p-2 h-11 w-11 mt-1 rounded-md flex justify-center items-center">
                  <svg
                    width="21"
                    height="24"
                    viewBox="0 0 21 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.7688 7.68435L19.9632 6.54873C20.2103 6.31113 20.3492 5.98887 20.3492 5.65285C20.3492 5.31683 20.2103 4.99458 19.9632 4.75698C19.716 4.51938 19.3808 4.38589 19.0313 4.38589C18.6818 4.38589 18.3466 4.51938 18.0994 4.75698L16.9182 5.90521C15.0788 4.53724 12.819 3.79503 10.4935 3.79503C8.16793 3.79503 5.90818 4.53724 4.06878 5.90521L2.87441 4.74436C2.62552 4.50676 2.28865 4.37394 1.93789 4.37512C1.58714 4.37631 1.25125 4.51139 1.0041 4.75067C0.756948 4.98994 0.618793 5.3138 0.620024 5.65101C0.621255 5.98821 0.76177 6.31113 1.01066 6.54873L2.21816 7.69697C0.778367 9.46038 -0.0028654 11.638 3.44255e-05 13.8798C-0.00425179 15.4891 0.391768 17.0761 1.15507 18.5084C1.91836 19.9407 3.02681 21.1768 4.38797 22.1136C5.74913 23.0503 7.32355 23.6607 8.97991 23.8937C10.6363 24.1266 12.3266 23.9755 13.9098 23.4529C15.4931 22.9303 16.9235 22.0513 18.0816 20.8893C19.2397 19.7272 20.0921 18.3158 20.5675 16.7728C21.043 15.2297 21.1278 13.5998 20.8149 12.0188C20.502 10.4378 19.8005 8.9517 18.7688 7.68435ZM10.5 21.4506C8.94251 21.4506 7.41995 21.0065 6.12492 20.1747C4.82988 19.3428 3.82052 18.1604 3.22448 16.777C2.62844 15.3936 2.47249 13.8714 2.77635 12.4028C3.08021 10.9342 3.83023 9.58521 4.93157 8.52642C6.03291 7.46763 7.4361 6.74658 8.9637 6.45446C10.4913 6.16234 12.0747 6.31226 13.5137 6.88528C14.9526 7.45829 16.1825 8.42866 17.0479 9.67367C17.9132 10.9187 18.375 12.3824 18.375 13.8798C18.375 15.8877 17.5453 17.8133 16.0685 19.2331C14.5917 20.6529 12.5886 21.4506 10.5 21.4506ZM7.87503 2.5236H13.125C13.4731 2.5236 13.807 2.39066 14.0531 2.15402C14.2993 1.91739 14.4375 1.59645 14.4375 1.2618C14.4375 0.927148 14.2993 0.606205 14.0531 0.369572C13.807 0.132939 13.4731 0 13.125 0H7.87503C7.52694 0 7.1931 0.132939 6.94696 0.369572C6.70081 0.606205 6.56253 0.927148 6.56253 1.2618C6.56253 1.59645 6.70081 1.91739 6.94696 2.15402C7.1931 2.39066 7.52694 2.5236 7.87503 2.5236ZM11.8125 10.0944C11.8125 9.75973 11.6743 9.43879 11.4281 9.20216C11.182 8.96552 10.8481 8.83258 10.5 8.83258C10.1519 8.83258 9.8181 8.96552 9.57196 9.20216C9.32581 9.43879 9.18753 9.75973 9.18753 10.0944V12.4792C8.89034 12.7347 8.68087 13.071 8.58683 13.4435C8.49279 13.816 8.51861 14.2072 8.66088 14.5653C8.80315 14.9234 9.05517 15.2315 9.38358 15.4488C9.71199 15.6662 10.1013 15.7826 10.5 15.7826C10.8988 15.7826 11.2881 15.6662 11.6165 15.4488C11.9449 15.2315 12.1969 14.9234 12.3392 14.5653C12.4815 14.2072 12.5073 13.816 12.4132 13.4435C12.3192 13.071 12.1097 12.7347 11.8125 12.4792V10.0944Z"
                      fill="#F1A27F"
                    />
                  </svg>
                </div>
                <div className="pl-2">
                  <div className=" text-black font-[700] text-[20px]">
                    {dashdata.avarege_response}
                  </div>
                  <p className="text-slate-500 text-sm pr-12">
                    Average Response Time
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        <div className="mt-4 bg-white h-[30rem]">
          <div className="flex items-center justify-between pt-6 px-6">
            <h4 className="text-lg font-[600] text-black">Campaigns</h4>
            <Link
              to={"/admin/campaign/list"}
              className="flex  rounded-md p-2 cursor-pointer  text-gray-300 text-sm items-center gap-x-4"
            >
              <button
                type="button"
                className="inline-block px-4 py-1.5 bg-yellow-500 text-white font-karla text-[12px] leading-tight rounded-full shadow-md hover:bg-yellow-600 hover:shadow-lg focus:bg-yellow-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-700 active:shadow-lg transition duration-150 ease-in-out"
              >
                Show More
              </button>
            </Link>
          </div>
          <CampaignList
            theadData={CamptheadData}
            user_type="admin"
            type="dashbaord"
          />
        </div>

        <div className="mt-4 h-[30rem] px-4 py-6 bg-white">
          <AgentChart
            label={dashdata.label}
            called={dashdata.called_data}
            tobe_called={dashdata.tobe_called}
          />
        </div>
        <div className="mt-4 h-[27rem] px-4 py-6 bg-white">
          <LineCharts
            label={dashdata?.months || []}
            answerd={dashdata?.answerd || []}
            not_answerd={dashdata?.not_answerd || []}
          />
        </div>
      </div>

      <div className="col-span-1 rounded-md">
        <RightBar recentCalls={recentCalls} agentstatus={agentstatus} creditData={creditData} setCreditData={setCreditData} />
      </div>
    </div>
  );
};

export default Dashboard;
